export default __webpack_public_path__ + "static/media/Icon-Proposals-White.55f20022.svg";